import { Component, OnInit } from '@angular/core';
import { Shared } from '../shared.service';
import { Sale } from '../sale';
import { Subject } from 'rxjs/Subject';
import 'rxjs/Rx';

@Component({
  selector: 'app-menu-settings',
  templateUrl: './menu-settings.component.html',
  styleUrls: ['./menu-settings.component.scss']
})
export class MenuSettingsComponent implements OnInit {

  popup = 0;
  numBoards = 0;
  saved;

  constructor(public shared: Shared) {
      this.saved = new Subject<any>();
  }

  add_sale(){
      let sale = new Sale;
      sale.tiers = 'all';
      this.shared.salesRef.push(sale);
  }

  save(){
      this.saved.next("saved");
      this.shared.userLocationRef.update({background : this.shared.userLocation.background});
  }

  ngOnInit() {
  }

  setPopup(step){
      this.popup = Number(step);
  }

  placeRequest(){
      this.setPopup(2);
  }

  increment(){
      this.numBoards++;
  }

  decrement(){
      this.numBoards--;
  }

}



// WEBPACK FOOTER //
// ./src/app/menu-settings/menu-settings.component.ts